<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Подъезды
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'block-add' }">+ Добавить подъезд</router-link>
    </h2>

    <resource-list
      url="/blocks"
      current-sort="number"
      init-sort-type="asc"
      resource-name="blocks"
      :show-per-page="false"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'blocks',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'full_name', label: 'Полный адрес', sort: false },
        { name: 'number', label: '№ подъезда', sort: true },
        { name: 'apartments_count', label: 'Кол-во квартир', sort: false }
      ],
      filters: {
        building: this.$route.params.building_id
      },
      actionRoutes: [
        { name: 'block-details', idName: 'block_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// Blocks.vue?49f78f74